export const endPoints = {
  BOSS_PAYMENT_STATISTIC: '/v1/mobile/payment/expected'
};
